import React from 'react'
import { useI18n } from '../../i18n'
import { GovernanceListingSection } from '../governance/GovernanceListingSection'
import wfStyles from '@/styles/pages/compliance-workflow/ComplianceWorkflow.module.scss'

interface Props {
  blockers?: Array<{ title: string; severity: string; description: string; blockerType?: string }>
  drift?: Array<{ driftType: string; severity: string; description: string }>
}

export default function CertificationReadinessWorkspace({ blockers = [], drift = [] }: Props) {
  const { t } = useI18n()
  return (
    <div className={wfStyles.innerStack}>
      <GovernanceListingSection title={t('complianceWorkflow.certificationWorkspace', 'Certification Workspace')}>
        {blockers.length === 0 ? (
          <p className={wfStyles.alertSuccess}>
            {t('complianceWorkflow.auditReady', 'Audit Ready')} — no open blockers.
          </p>
        ) : (
          <ul className={wfStyles.innerStack}>
            {blockers.map((b, i) => (
              <li key={i} className={wfStyles.alertError} title={b.description}>
                [{b.severity}] {b.title}
              </li>
            ))}
          </ul>
        )}
      </GovernanceListingSection>

      {drift.length > 0 ? (
        <GovernanceListingSection title={t('complianceWorkflow.complianceDrift', 'Compliance drift')}>
          <ul className={wfStyles.innerStack}>
            {drift.map((d, i) => (
              <li key={i} className={wfStyles.listItem}>
                <p className={wfStyles.itemMeta}>
                  {t('complianceWorkflow.driftDetected', 'Drift detected')}: {d.driftType} — {d.description}
                </p>
              </li>
            ))}
          </ul>
        </GovernanceListingSection>
      ) : null}
    </div>
  )
}
